<template>
  <div>
    <div :class="$style.container">
      <ToggleSwitch
        :data-test-id="$testId('status')"
        label="Disabled"
        labelOn="Enabled"
        :value="status"
        @input="toggleHandler"
      />
    </div>
    <hr :class="$style.hr">
    <div :class="$style.articleContainer">
      <Card
        :data-test-id="$testId('infoCard')"
      >
        <template v-slot:body>
          <Link
            :data-test-id="$testId('kbLink')"
            :href="CAPKbLink"
            isExternal
            target="_blank"
            text="Learn More: Conditional Access Policies"
          />
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import {
  Card, Link, ToggleSwitch,
} from '@jumpcloud/ui-components';

import { mapActions, mapGetters } from 'vuex';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

export default {
  name: 'PolicyStatus',

  components: {
    Card,
    Link,
    ToggleSwitch,
  },

  data() {
    return {
      CAPKbLink: KbArticleUrls.conditionalPoliciesGettingStarted,
    };
  },

  computed: {
    ...mapGetters('AuthNPolicyModel', [
      'item',
      'isItemBeingCreated',
    ]),

    status() {
      return !this.item.disabled;
    },
  },
  methods: {
    ...mapActions('AuthNPolicyModel', ['updateItem']),

    toggleHandler() {
      this.updateItem({
        ...this.item,
        disabled: !this.item.disabled,
      });
    },
  },
};
</script>

<style module>
.container {
  display: inline-flex;
  height: 48px;
  justify-content: center;
  margin-top: 24px;
  width: 100%;
}

.hr {
  border-top: 1px solid #e3e8e9;
  margin-left: 13%;
  width: 80%;
}

.articleContainer {
  display: inline-flex;
  justify-content: center;
  margin-left: 13%;
  margin-top: 30px;
  width: 80%;
}

.card {
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
